const localeEn = {
  en: {
    BREADCRUMB_1: 'Home',
    BREADCRUMB_2: 'Downloads',

    RESOURCE_NEW: 'New',
    RESOURCE_DOWNLOADS: 'downloads',
    RESOURCE_DOWNLOAD_BUTTON: 'Download',

    UNLOCKED_TITLE: 'Thank you for signing up!',
    UNLOCKED_SUBTITLE: 'Now start enjoying this resource.',

    FORM_TITLE_1: 'Sign up',
    FORM_TITLE_2: 'to',
    FORM_TITLE_3: 'download this resource',
    FORM_NAME: 'First Name',
    FORM_LASTNAME: 'Last Name',
    FORM_EMAIL: 'Email',
    FORM_COMPANY: 'Your Company Name',
    FORM_BUTTON: 'Sign Up',
    FORM_ERROR_REQUIRED: 'Required field',
    FORM_ERROR_MAX_LENGTH: 'Maximum 50 characters',
    FORM_ERROR_EMAIL: 'Please enter a valid email.',
    FORM_ERROR_LABEL: 'Error',
    FORM_RECOMMENDATIONS_TITLE:
      'You might also be interested in these resources',
    FORM_FIELD_ORG_SIZE: 'Number of Employees',
    FORM_COMPANY_SIZE_250: '1 to 250 employees',
    FORM_COMPANY_SIZE_1000: 'More than 1000 employees',
    FORM_COMPANY_SIZE_MORE_250: '251 to 999 employees',
    FORM_PHONE_LABEL: 'Phone Number',
    FORM_SELECT: 'Select',
    SHARE_RESOURCE: 'Share this article',
  },
};

export default localeEn;
